import React, {useEffect, useState} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {useHistory, useParams} from "react-router-dom";
import {editEmpleo, editStatus, getEmpleos} from '../../redux/empleo';


const EditarEmpleo = () => {
    let history = useHistory();
    const {id} = useParams();
    const lista_empleos = useSelector((store) => store.oft.empleos);
    const lista_estado = useSelector((store) => store.bases.estados)
    const edit_status = useSelector((store) => store.oft.edit_status);
    const {token} = useSelector((store) => store.auth);

    useEffect(() => {
        setEstados(lista_estado)
     }, [lista_estado]);

    // const [lista, setLista] = useState([]);
    const [msj, setMsj] = useState("");
    const dispatch = useDispatch();
    const [estados, setEstados] = useState([])
    const [data, setData] = useState({
        cargo: "",
        descripcion: "",
        requisitos: "",
        beneficios: "",
        habilidades: "",
        ciudad: "",
        modalidad: "",
        empresa: "",
        oferta: "",
        fecha_publicacion: null,
        fecha_caducidad: null,
        correos: [],
        estado_id: 0
    });

    useEffect(() => {
        if (lista_empleos.length > 0) {
            const data_find = lista_empleos.find(empleo => parseInt(empleo.id_oferta_empleo) === parseInt(id));
            setData(data_find);
        }
        if (edit_status === 200 && token) {
            dispatch(getEmpleos(token));
            dispatch(editStatus(0));
            history.push("/admin");
        } else if (edit_status === 1) {
            setMsj("Ocurrio un error al editar");

        }
    }, [lista_empleos, edit_status, token, id, dispatch, history]);

    // eslint-disable-next-line
    const {cargo, descripcion, requisitos, beneficios, habilidades, ciudad, oferta, fecha_publicacion, fecha_caducidad, correos, modalidad, empresa, estado_id} = data;

    const onInputChange = e => {
        if (e.target.name === 'estado_id') {
            setData({...data, [e.target.name]: parseInt(e.target.value)});
        } else if (e.target.name === 'fecha_publicacion' || e.target.name === 'fecha_caducidad') {
            setData({...data, [e.target.name]: e.target.value ? e.target.value : null});
        } else {
            setData({ ...data, [e.target.name]: e.target.value });
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!cargo || !descripcion || !requisitos || !beneficios || !habilidades || !ciudad || !modalidad || !empresa ||  !oferta || !token || !estado_id) {
            setMsj("Completa todos los campos");
        } else {
            if (token) {
                dispatch(editEmpleo(id, data, token));
            }
        }
    };

    const canceled = () => {
        if (token) {
            dispatch(getEmpleos(token));
        }
        dispatch(editStatus(0));
        history.push("/admin");
    }
    const addCorreo = () => {
        setData({...data, correos: [...correos, '']});

    }
    const handleRemove = (count) => {
        correos.pop(count);
        setData({...data, correos: [...correos]});
    }


    const handleCorreo = (i, e) => {
        correos[i] = e.target.value;
        setData({...data, correos: [...correos]});
    }

    return (
        <>
            <div className="section-header">
                <h1>{`Editar Oferta ${cargo}`} </h1>
            </div>
            <div className="col-12 col-md-12 col-lg-12">
                <div className="card">
                    <form onSubmit={(e) => handleSubmit(e)}>
                        <div className="card-header">
                            <h4>Datos de la oferta laboral</h4>
                        </div>
                        {
                            msj ? (<div class="alert alert-danger m-3">
                                {msj}
                            </div>) : (null)
                        }
                        <div className="card-body row">

                            <div className="col-6 col-md-6 col-lg-6">
                                <div className="form-group">
                                    <label>Cargo</label>
                                    <input type="text" name="cargo"
                                           className="form-control" required=""
                                           value={cargo}
                                           onChange={e => onInputChange(e)}/>
                                </div>
                                <div className="form-group mb-0">
                                    <label>Descripción</label>
                                    <textarea className="form-control"
                                              name="descripcion" required=""
                                              value={descripcion}
                                              style={{height: '200px'}}
                                              onChange={e => onInputChange(e)}></textarea>
                                </div>
                                <div className="form-group mb-0">
                                    <label>Requisitos</label>
                                    <textarea className="form-control" name="requisitos"
                                              value={requisitos}
                                              style={{height: '200px'}}
                                              required="" onChange={e => onInputChange(e)}></textarea>
                                </div>
                                <div className="form-group mb-0">
                                    <label>Beneficios</label>
                                    <textarea className="form-control" name="beneficios"
                                              value={beneficios}
                                              style={{height: '200px'}}
                                              required="" onChange={e => onInputChange(e)}></textarea>
                                </div>
                                <div className="form-group mb-0">
                                    <label>Habilidades</label>
                                    <textarea className="form-control" name="habilidades"
                                              value={habilidades}
                                              style={{height: '200px'}}
                                              required="" onChange={e => onInputChange(e)}></textarea>
                                </div>
                            </div>
                            <div className="col-6 col-md-6 col-lg-6">
                                <button type="button" className="btn btn-success" onClick={() => addCorreo()}><i
                                    class="fas fa-plus"></i></button>

                                {
                                    correos.map((c, i) => {
                                        return <div className="form-group row ml-3">
                                            <label className="col-12">Correo</label>
                                            <input type="email" className="form-control col-8" name="correos" value={c}
                                                   required="" onChange={e => handleCorreo(i, e)}/>
                                            <button className="btn btn-danger col-1" type="button"
                                                    onClick={() => handleRemove(i)}><i class="fas fa-times"></i>
                                            </button>

                                        </div>
                                    })
                                }
                                {/*<div className="form-group">*/}
                                {/*    <label>Ciudad</label>*/}
                                {/*    <input type="text" className="form-control" value={ciudad}*/}
                                {/*           name="ciudad" required="" onChange={e => onInputChange(e)}/>*/}
                                {/*</div>*/}
                                <div className="form-group">
                                    <label>Modalidad</label>
                                    <input type="text" className="form-control" value={modalidad}
                                           name="modalidad" required="" onChange={e => onInputChange(e)}/>
                                </div>
                                <div className="form-group">
                                    <label>Empresa</label>
                                    <input type="text" className="form-control" value={empresa}
                                           name="empresa" required="" onChange={e => onInputChange(e)}/>
                                </div>
                                <div className="form-group">
                                    <label>Ciudad</label>
                                    <input type="text" className="form-control" value={ciudad}
                                           name="ciudad" required="" onChange={e => onInputChange(e)}/>
                                </div>
                                <div className="form-group">
                                    <label>Oferta</label>
                                    <input type="text" className="form-control"
                                           value={oferta}
                                           name="oferta" required="" onChange={e => onInputChange(e)}/>
                                </div>
                                <div className="form-group">
                                    <label>Fecha Publicación</label>
                                    <input type="datetime-local" name="fecha_publicacion"
                                           value={fecha_publicacion}
                                           className="form-control" onChange={e => onInputChange(e)}/>
                                </div>
                                <div className="form-group">
                                    <label>Fecha Caducidad</label>
                                    <input type="datetime-local" name="fecha_caducidad" className="form-control"
                                           onChange={e => onInputChange(e)} value={fecha_caducidad}/>
                                </div>
                                <div className="form-group">
                                    <label>Estado</label>
                                    <select className="form-control" name="estado_id" onClick={e => onInputChange(e)}>
                                        <option value={0}>Seleccione una opcion</option>
                                        {
                                            estados ? estados.map(e => <option value={e.id_estado} key={e.id_estado} selected={(parseInt(e.id_estado) === parseInt(estado_id)) ? true : false}>{e.descripcion}</option>) : null
                                        }
                                    </select>
                                </div>
                            </div>
                        </div>

                        <div className="card-footer text-right">
                            <button type="submit" className="btn btn-success">Guardar</button>

                            <button type="button" className="btn btn-danger" onClick={() => canceled()}>Cancelar
                            </button>
                        </div>
                    </form>
                </div>

            </div>
        </>
    )
}

export default EditarEmpleo;